import { useQuery } from '@tanstack/react-query'
import { getPublishDraft } from './publish-draft.api'

export const publishDraftQueryKeys = {
  all: ['publish', 'draft'] as const,
  detail: (instrumentId: string) =>
    [...publishDraftQueryKeys.all, instrumentId] as const,
}

export function usePublishDraftQuery(instrumentId: string, enabled: boolean) {
  return useQuery({
    queryKey: publishDraftQueryKeys.detail(instrumentId),
    queryFn: () => getPublishDraft(instrumentId),
    enabled: enabled && instrumentId.length > 0,
    staleTime: 60_000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  })
}
